import React from 'react';
import { Field } from 'formik';

import { InputUI, AutoCompleteSelectUI, FormErrorUI, FormLabelUI, CheckboxUI } from '../../Interface';

export const ResourceFourFields = ({
  viewField,
  submenuId,
  selectedValues,
  values,
  validateField,
  setFieldValue,
  errors,
}) => {
  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 ">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Erőforrás neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="groupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Erőforrás csoportja" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.groupId} />}
          onChange={(_e, newVal) => {
            setFieldValue('groupId', newVal?.value ?? null).then(() => {
              validateField('groupId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.groupId !== '' }}
          selectedValue={values.groupId}
          selectedLabelValue={selectedValues?.resourceGroup?.itemName}
          table={['ProjectGroupListitems', 'ProjectGroup']}
          joins={'ProjectGroupListitems.projectGroupStatusId = ProjectGroup.projectGroupStatusId'}
          listType={{ id: 'itemId', name: 'itemName' }}
          conditions={`ProjectGroup.subMenuId = ${submenuId}`}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="statusId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Státusz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.statusId} />}
          onChange={(_e, newVal) => {
            setFieldValue('statusId', newVal?.value ?? null).then(() => {
              validateField('statusId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.statusId !== '' }}
          selectedValue={values.statusId}
          selectedLabelValue={selectedValues?.status?.itemName}
          table={['statusitems', 'status']}
          listType={{ id: 'itemId', name: 'itemName' }}
          joins={'statusitems.statusId = status.statusId'}
          conditions={[`statusitems.archive = 'N'`, `status.subMenuId = ${submenuId}`]}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="typeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.typeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('typeId', newVal?.value ?? null).then(() => {
              validateField('typeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.typeId !== '' }}
          selectedValue={values.typeId}
          selectedLabelValue={selectedValues?.type?.itemName}
          table={['typeitems', 'type']}
          listType={{ id: 'itemId', name: 'itemName' }}
          joins={'typeitems.typeId = type.typeId'}
          conditions={[`typeitems.archive = 'N'`, `type.subMenuId = ${submenuId}`]}
        />
      </div>
      <div className="md:col-span-2 col-span-4 pt-2">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};
